import { render, staticRenderFns } from "./DadosUnificados.vue?vue&type=template&id=3c45422b&scoped=true"
import script from "./DadosUnificados.vue?vue&type=script&lang=js"
export * from "./DadosUnificados.vue?vue&type=script&lang=js"
import style0 from "./DadosUnificados.vue?vue&type=style&index=0&id=3c45422b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45422b",
  null
  
)

export default component.exports